import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const BatchTransactionView = lazy(() => import('./views/BatchTransactionView'));

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Spin size="large" tip="Loading…" />
  </div>
);

export const batchTransactionRoutes: RouteObject[] = [
  {
    path: 'transactions',
    children: [
      {
        path: 'batch',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <BatchTransactionView />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'batch-transactions',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <BatchTransactionView />
          </Suspense>
        ),
      },
    ],
  },
];

export default batchTransactionRoutes;
